import type { ReactNode } from 'react';

export const symbol_view_array: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M120-250v-460q0-20.83 14.62-35.42Q149.24-760 170.12-760q20.88 0 35.38 14.58Q220-730.83 220-710v460q0 20.83-14.62 35.42Q190.76-200 169.88-200q-20.88 0-35.38-14.58Q120-229.17 120-250Zm210 50q-20.83 0-35.42-14.58Q280-229.17 280-250v-460q0-20.83 14.58-35.42Q309.17-760 330-760h300q20.83 0 35.42 14.58Q680-730.83 680-710v460q0 20.83-14.58 35.42Q650.83-200 630-200H330Zm410-50v-460q0-20.83 14.62-35.42Q769.24-760 790.12-760q20.88 0 35.38 14.58Q840-730.83 840-710v460q0 20.83-14.62 35.42Q810.76-200 789.88-200q-20.88 0-35.38-14.58Q740-229.17 740-250Zm-400-10h280v-440H340v440Zm140-220Z"
		/>
	</svg>
);
